// Broadcast channel for auth state synchronization
export const authChannel =
  typeof window !== "undefined" ? new BroadcastChannel("auth") : null;

export const broadcastSignOut = () => {
  authChannel?.postMessage({ 
    type: "signout", 
    timestamp: Date.now() 
  });
};

// Only the fact of a change is posted: the session itself (which can carry a
// one-use impersonation proof) never leaves the tab that wrote it.
export const broadcastSessionUpdate = () => {
  authChannel?.postMessage({
    type: "session_update",
    timestamp: Date.now()
  });
};

export const setupAuthListener = (router, sessionUpdate) => {
  if (!authChannel) return;

  const handleAuthMessage = async (event) => {
    const { type, timestamp } = event.data;
    
    // Ignore old messages (older than 5 seconds)
    if (Date.now() - timestamp > 5000) return;

    switch (type) {
      case "signout":
        // Clear the session immediately using NextAuth's update mechanism
        if (sessionUpdate) {
          await sessionUpdate(null);
        }

        // The auth cookies are httpOnly, so script cannot clear them; signing
        // out clears them on the server. Reload so every component resets
        // against the signed-out session.
        // eslint-disable-next-line @next/next/no-location-assign-relative-destination -- Reload the document to discard cached data after an identity change.
        window.location.href = "/";
        break;
        
      case "session_update":
        // The originating tab already rewrote the shared session cookie, so
        // every other tab only needs to re-read it. Replaying the change here
        // would fail: an impersonation's one-use proof is rejected on a second
        // use and signs the whole browser out.
        if (sessionUpdate) {
          await sessionUpdate();
        }
        break;
    }
  };

  authChannel.onmessage = handleAuthMessage;
};
